var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.37 20.616a1.7 1.7 0 0 1 1.626-1.206h32a1.7 1.7 0 0 1 1.555 2.387L76.827 59.662h32.947a1.7 1.7 0 0 1 1.382 2.69l-49.778 69.526a1.701 1.701 0 0 1-3.02-1.445l13.624-49.075H42.218a1.7 1.7 0 0 1-1.626-2.194l17.777-58.548Zm2.887 2.194L44.51 77.958h29.707a1.7 1.7 0 0 1 1.638 2.155l-11.654 41.98 42.264-59.031H74.218a1.7 1.7 0 0 1-1.555-2.387L89.387 22.81h-28.13Zm-45.57 1.32a1.7 1.7 0 0 1 2.403 0l8.957 8.957a1.7 1.7 0 1 1-2.404 2.404l-8.957-8.956a1.7 1.7 0 0 1 0-2.404ZM127.87 117.02a1.7 1.7 0 1 0-2.404 2.404l8.957 8.957a1.7 1.7 0 1 0 2.404-2.404l-8.957-8.957Zm8.44-92.888a1.7 1.7 0 0 0-2.404 0l-8.957 8.956a1.7 1.7 0 1 0 2.404 2.404l8.957-8.956a1.7 1.7 0 0 0 0-2.404ZM24.137 117.019a1.7 1.7 0 1 1 2.404 2.404l-8.957 8.957a1.7 1.7 0 1 1-2.404-2.404l8.957-8.957Z",
    fill: "#3489F3"
  })));
};

export default SvgError;